module.exports = __webpack_public_path__ + "static/media/reception-2.eccec35e.jpg";